import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import UserInviteByPhoneUI from './UserInviteByPhoneUI.js'

class UserInviteByPhoneSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // phone
      phone: '',
      phoneError: null,
      // role
      accountRoleId: '',
      accountRoleList: null,
      accountRoleError: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <UserInviteByPhoneUI
        context={this.props.context}
        messageList={this.props.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // phone
        phone={this.state.phone}
        onPhoneChange={(event) => { this.setState({ phone: event.target.value }) }}
        phoneError={this.state.phoneError}
        setPhoneError={(error) => { this.setState({ phoneError: error }) }}
        // account role
        accountRoleId={this.state.accountRoleId}
        accountRoleList={this.state.accountRoleList}
        onaccountRoleIdChange={(event) => { this.setState({ accountRoleId: event.target.value }) }}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
      />
    )
  }

  UNSAFE_componentWillMount() {
    let context = this.props.context
    this.getAccountRoles(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/users/phone`,
      this.onSubmitCallback, {
      phoneNumber: this.state.phone,
      accountRoleId: this.state.accountRoleId,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'phoneNumber':
          this.setState({ phoneError: error.message })
          break;
        case 'accountRoleId':
          this.setState({ accountRoleError: error.message })
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.AccountUsers(this.props.context.session.accountId))
      setTimeout(() => {
        this.setState({
          phone: '',
          successMsg: null
        })
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  getAccountRoles(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/roles/account`,
      cacheKey: CacheKeys.Roles('account', context.locale),
      callback: this.getAccountRolesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, { locales: context.locale })
  }

  getAccountRolesCallback = (response) => {
    let nonOwnerRoleList = response.roleList.filter(role => !role.ownerRole).map(role => ({ key: role.roleId, value: role.roleName }))
    this.setState({
      accountRoleList: nonOwnerRoleList,
      accountRoleId: nonOwnerRoleList[1].key
    })
  }
}

export default withRouter(UserInviteByPhoneSF)
